export default __webpack_public_path__ + "static/media/LC.46ec9f4c.svg";